import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../context/AuthContext';

/**
 * PrivateRoute - Authentication and authorization guard
 * Redirects to login if user is not authenticated or has no roles
 */
export const PrivateRoute = ({ children }: any) => {
    const { loggedInUser, roles, rolesVerified } = useAuthStore();
    const location = useLocation();

    // If not logged in, redirect to login preserving the original URL
    if (!loggedInUser) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If roles have been verified and user has no roles, redirect to login with error
    if (rolesVerified && roles.length === 0) {
        return <Navigate to="/login?error=no-roles" />;
    }

    // Allow access - either roles verified with roles, or still loading roles
    return children;
};
